// src/pages/Customer/components/OrderTable.js
import { Table, Button, Space } from 'antd';
import { FilePdfOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { formatPrice, getTaxStatus } from '../../../utils/common';

const InvoiceTable = ({ invoices, loading, downloadPDF }) => {

  const columns = [
    // { title: 'No', dataIndex: 'id', key: 'id' },
    // { 
    //   title: 'Customer', 
    //   dataIndex: 'customer', 
    //   key: 'customer',
    //   render: (value) => `${value.name} (${value.code})`,
    // },
    {
      title: 'Invoice Date',
      dataIndex: 'invoice_date',
      key: 'invoice_date',
      render: (value) => dayjs(value).format('MM/DD/YYYY'),
    },
    {
      title: 'Invoice Due Date',
      dataIndex: 'invoice_due_date',
      key: 'invoice_due_date',
      render: (value) => dayjs(value).format('MM/DD/YYYY'),
    },
    {
      title: 'Invoice Price',
      key: 'invoice_price',
      render: (_, record) => {
        const salePrice = +record.sub_total - +record.total_discount;
        return formatPrice(salePrice);
      },
    },
    {
      title: 'Estimated Tax',
      key: 'estimated_tax',
      render: (_, record) => {
        if (record.avalara_response?.summary?.length > 0) {
          let tax = 0;
          record.avalara_response.summary.map(taxSummary => {
            if (+taxSummary.tax > 0) {
              tax += +taxSummary.tax;
            }
          })
          return formatPrice(tax);
        }
        return 'NA';
      },
    },
    {
      title: 'Payments/Credit',
      dataIndex: 'credits',
      key: 'credits',
      render: (value) => formatPrice(value),
    },
    {
      title: 'Total',
      dataIndex: 'total',
      key: 'total',
      render: (_, record) => {
        let total = +record.total;
        if (record.avalara_response?.summary?.length > 0) {
          record.avalara_response.summary.map(taxSummary => {
            if (+taxSummary.tax > 0) {
              total += +taxSummary.tax;
            }
          })
        }
        return formatPrice(total);
      },
    },
    {
      title: 'Tax Status',
      // dataIndex: 'status',
      key: 'status',
      render: (_, record) => {
        let value = record.status;
        if (!record.is_taxed) {
          value = -1;
        }
        return getTaxStatus(value);
      },
    },
    {
      title: 'Invoice Actions', key: 'actions',
      render: (_, record) => (<Space gap="small" wrap>
        <Button icon={<FilePdfOutlined />} onClick={() => downloadPDF(record.id)}>Download</Button>
      </Space>
    )
  }
  ];

  return (
    <Table
      dataSource={invoices}
      columns={columns}
      rowKey="id"
      loading={loading}
      scroll={{ x: 'max-content' }}
      size="small"
      pagination={invoices?.length > 10 || false}
    />
  );
};

export default InvoiceTable;
